import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import BasicHtmlContent from "../src/components/templates/BasicHtmlContent/BasicHtmlContent";
export default function RefundPolicy() {
  return /*#__PURE__*/_jsxs(BasicHtmlContent, {
    title: "Refunds/Cancellations Policy | Get Mutual Transfer",
    children: [/*#__PURE__*/_jsx("h1", {
      style: {
        textAlign: "center"
      },
      children: "Refunds/Cancellations Policy"
    }), "Once your subscription starts you can't get a refund for any payments you've already made. You will still have access to the subscription until the end of the period you have paid for."]
  });
}